import {
  JobView,
  Profile,
  Settings,
  Dashboard,
  JobCreation,
  AdminDashboard,
  CompanyUserMgt,
  // PropertyForm,
  // ConditionalForm,
  ElevationForm,
  Questionnaire,
  AllJobs,
  SurveyRequest,
} from "./pages";

const userRole = localStorage.getItem("userRole");

export default {
  items:
    userRole === "Admin"
      ? [
          {
            path: "/",
            name: "Dashboard",
            type: "link",
            component: AdminDashboard,
          },
          {
            path: "/all-jobs",
            name: "AllJobs",
            type: "link",
            component: AllJobs,
          },
          {
            path: "/survey-request",
            name: "SurveyRequest",
            type: "link",
            component: SurveyRequest,
          },
          {
            path: "/CompanyUserMgt",
            name: "CompanyUserMgt",
            type: "link",
            component: CompanyUserMgt,
          },
          {
            path: "/JobCreation/:id",
            name: "JobCreation",
            type: "link",
            component: JobCreation,
          },
          {
            path: "/JobView/:id",
            name: "JobView",
            type: "link",
            component: JobView,
          },
          {
            path: "/Profile/:id",
            name: "Profile",
            type: "link",
            component: Profile,
          },
          {
            path: "/Settings",
            name: "Settings",
            type: "link",
            component: Settings,
          },
        ]
      : [
          {
            path: "/",
            name: "Dashboard",
            type: "link",
            component: Dashboard,
          },
          {
            path: "/CompanyUserMgt",
            name: "CompanyUserMgt",
            type: "link",
            component: CompanyUserMgt,
          },
          {
            path: "/JobCreation/:id",
            name: "JobCreation",
            type: "link",
            component: JobCreation,
          },
          {
            path: "/JobView/:id",
            name: "JobView",
            type: "link",
            component: JobView,
          },
          {
            path: "/Profile/:id",
            name: "Profile",
            type: "link",
            component: Profile,
          },
          {
            path: "/Settings",
            name: "Settings",
            type: "link",
            component: Settings,
          },

          {
            path: "/ElevationForm/:id",
            name: "ElevationForm",
            type: "link",
            component: ElevationForm,
          },
          {
            path: "/Questionnaire/:id",
            name: "Questionnaire",
            type: "link",
            component: Questionnaire,
          },
        ],
};



// WEBPACK FOOTER //
// ./src/routes.js